import React from "react";

const GhostCreation = ({ showCheckbox, onChange }) => {
  if (!showCheckbox) return null;

  return (
    <div className="form-group">
      <div className="form-check">
        <input
          id="ghost"
          type="checkbox"
          name="ghost"
          className="form-check-input"
          onChange={onChange}
        />
        <label className="form-check-label" htmlFor="ghost">
          Ghost creation
        </label>
      </div>
    </div>
  );
};

export default GhostCreation;
